module.exports = __webpack_public_path__ + "static/ine-3fd525a9021b061653e2c8d2156d1df8.svg";